<div class="additionalExplanation-layout">
  <h2>
    additional explanation
    <span class="add" (click)="openAdd()">add explanation</span>
  </h2>
  <div class="row">
    <div class="table-helper box-shadow">
      <table class="table-list">
        <thead>
          <tr>
            <td>
              <span>name</span>
            </td>
            <td>
              <span>contravention</span>
            </td>
            <td>
              <span>reason</span>
            </td>
            <td>
              <span>location (Name)</span>
            </td>
            <td>
              <span>letter Text</span>
            </td>
            <td>
              <span>placement</span>
            </td>
            <td>
              <span>active</span>
            </td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let explanation of additionalExplanations; trackBy: trackByExplanationId">
            <td>{{explanation.name}}</td>
            <td>{{explanation.contraventionId}}</td>
            <td>{{explanation.reason}}</td>
            <td>{{explanation.locationName}}</td>
            <td>{{explanation.letterText}}</td>
            <td>{{ getOrderName(explanation.order) }}</td>
            <td>{{explanation.active}}</td>
            <td class="link" (click)="openEdit(explanation.id)">
              edit
            </td>
            <td class="link" (click)="openDelete(explanation.id)">
              delete
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <br />

  <div class="location-management-layout">
    <h2>
      location management
      <span class="add" (click)="openAddLocation()">add location</span>
    </h2>

    <!-- Location Table -->
    <div class="table-helper box-shadow">
      <table class="table-list">
        <thead>
          <tr>
            <td><span>location name</span></td>
            <td><span>description</span></td>
            <td><span>location type</span></td>
            <td><span>active</span></td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let location of locations">
            <td>{{ location.name }}</td>
            <td>{{ location.description }}</td>
            <td>{{ location.locationType }}</td>
            <td>{{ location.active }}</td>
            <td class="link" (click)="openEditLocation(location.id)">edit</td>
            <td class="link" (click)="openDeleteLocation(location.id)">delete</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div id="kendoEdit">
    <kendo-dialog *ngIf="openedEdit" (close)="closeEdit()">
      <kendo-dialog-titlebar id="editTitle">
        <div style="font-size: 18px; line-height: 1.3em;">
          edit additional explanation
        </div>
      </kendo-dialog-titlebar>

      <form id="ExplanationEdit" #userForm="ngForm" (ngSubmit)="saveEdit(userForm)">
        <label for="explanationToEdit.name">name:</label><br>
        <input aria-label="" [(ngModel)]="explanationToEdit.name" name="name" placeholder="{{explanationToEdit.name}}"
          class="k-textbox" required />
        <div *ngIf="explanationToEdit.name !== '' "
          [ngStyle]="{'color': (explanationToEdit.name.length > 250) ? 'red' : inherit}">
          {{explanationToEdit.name.length }}/250</div><br>
        <div *ngIf="userForm.form.controls['name'].invalid && userForm.form.controls['name'].touched"
          class="additionalExplanationErrors">
          <br>
          name is required
        </div>
        <div *ngIf="explanationToEdit.name.length > 250" class="additionalExplanationErrors">
          name is too long (max 250 characters)
        </div><br>

        <label for="explanationToEdit.contravention">contravention:</label><br>
        <input aria-label="" [(ngModel)]="explanationToEdit.contraventionId" name="contraventionId"
          placeholder="{{explanationToEdit.contraventionId}}" class="k-textbox" /><br><br>

        <label for="explanationToEdit.reason">Reason:</label><br>
        <div style="display: flex; align-items: center; justify-content: space-between;">{{ explanationToEdit.reason || 'No reason selected' }}
          <button type="button" class="clear-btn" (click)="clearReason('edit')">clear</button>
        </div>
        <br><br>

        <label for="explanationToEdit.reason">Reason search:</label><br>
        <input aria-label="" type="text" id="search" [(ngModel)]="searchText" placeholder="Search new reason"
          (input)="searchTerms.next($event.target.value)" />

        <div>
          <button class="kendo-dialog-button" *ngFor="let reason of filteredReasons"
            [ngClass]="{'selected-button': reason.id === explanationToEdit.ricId}"
            (click)="selectReason(reason.id, reason, 'edit')">
            {{ reason.caption }}
          </button>
        </div>
        <br><br>

        <!-- Hidden input to store the selected ricId -->
        <input aria-label="" type="hidden" [(ngModel)]="explanationToEdit.ricId" name="ricId" />


        <label for="explanationToEdit.locationId">Location:</label><br>
        <div style="display: flex; align-items: center;">
          <select [(ngModel)]="explanationToEdit.locationId" name="locationId" class="kendo-dropdownlist">
            <option value="" disabled selected>Select a location</option>
            <option *ngFor="let location of explanationToEdit.locations" [value]="location.id">
              {{ location.name }}
            </option>
          </select>

          <!-- Clear button to reset location selection -->
          <button type="button" class="clear-btn" (click)="clearLocation('edit')">clear</button>
        </div>
        <br>


        <label for="explanationToEdit.explanation">explanation:</label><br>
        <textarea [(ngModel)]="explanationToEdit.letterText" name="letterText"
          placeholder="{{explanationToEdit.letterText}}" class="k-textbox" type="text" rows="5" required></textarea>
        <div *ngIf="explanationToEdit.letterText !== '' "
          [ngStyle]="{'color': (explanationToEdit.letterText.length > 8000) ? 'red' : inherit}">{{
          explanationToEdit.letterText.length }}/8000</div><br>
        <input aria-label="" type="hidden" [(ngModel)]="explanationToEdit.textResourceId"
          name="explanationToEdit.textResourceId" />
        <div *ngIf="userForm.form.controls['letterText'].invalid && userForm.form.controls['letterText'].touched"
          class="additionalExplanationErrors">
          <br>
          explanation is required
        </div>
        <div *ngIf="explanationToEdit.letterText.length > 8000" class="additionalExplanationErrors">
          explanation is too long (max 8000 characters)
        </div><br>

        <!-- <label for="explanationToEdit.order">order:</label><br>
        <input aria-label="" type="number" [(ngModel)]="explanationToEdit.order" name="order" class="k-textbox" required
          min="1" /><br><br> -->
          <label for="explanationToEdit.order">placement:</label><br>
          <select [(ngModel)]="explanationToEdit.order" name="order" class="kendo-dropdownlist" required>
            <option value="1">start of explanations</option>
            <option value="2">end of explanations</option>
            <option value="3">after selected reason</option>
          </select>
          <br><br>
        <div *ngIf="userForm.form.controls['order'].invalid && userForm.form.controls['order'].touched"
          class="additionalExplanationErrors">
          placement is required
        </div>

        <label for="explanationToEdit.active" class="toggle-switch-label">active:</label>
        <label class="toggle-switch">
          <input aria-label="" type="checkbox" [(ngModel)]="explanationToEdit.active" name="active"
            id="explanationToEdit.active">
          <span class="slider"></span>
        </label><br><br>

      </form>

      <div>
        <button kendoButton class="kendo-dialog-button" (click)="closeEdit()" role="button">cancel</button>
        <button kendoButton class="kendo-dialog-button" (click)="saveEdit(userForm)"
          [disabled]="explanationToEdit.letterText.length > 8000 || explanationToEdit.name.length > 250">save</button>
      </div>
    </kendo-dialog>
  </div>

  <div id="kendoAdd">
    <kendo-dialog *ngIf="openedAdd" (close)="closeAdd()">

      <kendo-dialog-titlebar id="addtitle">
        <div style="font-size: 18px; line-height: 1.3em;">
          add additional explanation
        </div>
      </kendo-dialog-titlebar>

      <form id="ExplanationAdd" #userForm="ngForm" (ngSubmit)="saveAdd(userForm)">
        <label for="explanation.name">name:</label><br>
        <input aria-label="" [(ngModel)]="createExplanation.name" name="name" class="k-textbox" required />
        <div *ngIf="createExplanation.name !== '' "
          [ngStyle]="{'color': (createExplanation.name.length > 250) ? 'red' : inherit}">{{
          createExplanation.name.length }}/250</div><br>
        <div *ngIf="userForm.form.controls['name'].invalid && userForm.form.controls['name'].touched"
          class="additionalExplanationErrors">
          <br>
          name is required
        </div>
        <div *ngIf="createExplanation.name.length > 250" class="additionalExplanationErrors">
          name is too long (max 250 characters)
        </div><br>

        <label for="explanation.contravention">contravention:</label><br>
        <input aria-label="" [(ngModel)]="createExplanation.contraventionId" name="contraventionId"
          class="k-textbox" /><br><br>

        <label for="createExplanation.reason">Reason:</label><br>
        <input aria-label="" type="text" id="search" [(ngModel)]="searchText" placeholder="Type to search..."
          (input)="searchTerms.next($event.target.value)">

        <div>
          <button class="kendo-dialog-button" *ngFor="let reason of filteredReasons"
            [ngClass]="{'selected-button': reason.id === createExplanation.ricId}"
            (click)="selectReason(reason.id, reason, 'create')">
            {{ reason.caption }}
          </button>
        </div>
        <br><br>

        <!-- Hidden input to store the selected ricId -->
        <input aria-label="" type="hidden" [(ngModel)]="createExplanation.ricId" name="ricId" />

        <!-- <label for="explanation.location">location:</label><br>
        <select [(ngModel)]="createExplanation.locationId" name="createExplanation.locationId"
          class="kendo-dropdownlist" (change)="updateLocationAdd($event)">
          <option *ngFor="let location of createExplanation.locations" [value]="location.id">{{ location.name }}
          </option>
        </select><br><br>
        <input aria-label="" type="hidden" [(ngModel)]="createExplanation.locationId"
          name="createExplanation.locationId" /> -->

        <label for="createExplanation.locationId">Location:</label><br>
        <div style="display: flex; align-items: center;">
          <select [(ngModel)]="createExplanation.locationId" name="locationId" class="kendo-dropdownlist">
            <option value="" disabled selected>Select a location</option>
            <option *ngFor="let location of createExplanation.locations" [value]="location.id">
              {{ location.name }}
            </option>
          </select>

          <!-- Clear button to reset location selection -->
          <button type="button" class="clear-btn" (click)="clearLocation('create')">clear</button>
        </div>
        <br>


        <label for="explanation.explanation">explanation:</label><br>
        <textarea [(ngModel)]="createExplanation.letterText" name="letterText" class="k-textbox" rows="5"
          required></textarea>
        <div *ngIf="createExplanation.letterText !== '' "
          [ngStyle]="{'color': (createExplanation.letterText.length > 8000) ? 'red' : inherit}">{{
          createExplanation.letterText.length }}/8000</div><br>
        <input aria-label="" type="hidden" [(ngModel)]="createExplanation.textResourceId"
          name="createExplanation.textResourceId" />
        <div *ngIf="userForm.form.controls['letterText'].invalid && userForm.form.controls['letterText'].touched"
          class="additionalExplanationErrors">
          <br>
          explanation is required
        </div>
        <div *ngIf="createExplanation.letterText.length > 8000" class="additionalExplanationErrors">
          explanation is too long (max 8000 characters)
        </div><br>

        <label for="createExplanation.order">placement:</label><br>
        <select [(ngModel)]="createExplanation.order" name="order" class="kendo-dropdownlist" required>
          <option value="1">start of explanations</option>
          <option value="2">end of explanations</option>
          <option value="3">after selected reason</option>
        </select>
        <br><br>
        <div *ngIf="userForm.form.controls['order'].invalid && userForm.form.controls['order'].touched"
          class="additionalExplanationErrors">
          placement is required
        </div>

        <label for="explanation.active" class="toggle-switch-label">Active:</label>
        <label class="toggle-switch">
          <input aria-label="" type="checkbox" [(ngModel)]="createExplanation.active" name="active"
            id="explanation.active">
          <span class="slider"></span>
        </label><br><br>
      </form>

      <div>
        <button kendoButton class="kendo-dialog-button" (click)="closeAdd()" role="button">cancel</button>
        <button kendoButton class="kendo-dialog-button" (click)="saveAdd(userForm)"
          [disabled]="createExplanation.letterText.length > 8000 || createExplanation.name.length > 250">save</button>
      </div>

    </kendo-dialog>
  </div>

  <div>
    <kendo-dialog *ngIf="openedDelete" (close)="closeDelete()">
      <kendo-dialog-titlebar>
        <div style="font-size: 18px; line-height: 1.3em;">
          <span class="k-icon k-i-warning k-icon-md"></span> delete explanation?
        </div>
      </kendo-dialog-titlebar>
      <p style="margin: 30px; text-align: center;">
        are you sure you want to delete the explanation?
      </p>
      <kendo-dialog-actions>
        <button kendoButton class="kendo-dialog-button" (click)="closeDelete()" role="button">no</button>
        <button kendoButton class="kendo-dialog-button" (click)="confirmDelete()">yes</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  </div>

  <!-- Add Location Modal -->
  <div id="kendoAddLocation">
    <kendo-dialog *ngIf="openedAddLocation" (close)="closeAddLocation()">
      <kendo-dialog-titlebar id="addTitle">
        <div style="font-size: 18px; line-height: 1.3em;">
          add Location
        </div>
      </kendo-dialog-titlebar>

      <form id="LocationAdd" #userForm="ngForm" (ngSubmit)="saveAddLocation(userForm)">
        <label for="createLocation.name">name:</label><br>
        <input aria-label="" [(ngModel)]="createLocation.name" name="name" class="k-textbox" required />
        <div *ngIf="createLocation.name !== '' "
          [ngStyle]="{'color': (createLocation.name.length > 250) ? 'red' : inherit}">{{ createLocation.name.length
          }}/250</div><br>
        <div *ngIf="userForm.form.controls['name'].invalid && userForm.form.controls['name'].touched"
          class="additionalExplanationErrors">
          <br>
          name is required
        </div>
        <div *ngIf="createLocation.name.length > 250" class="additionalExplanationErrors">
          name is too long (max 250 characters)
        </div><br>

        <label for="createLocation.description">description:</label><br>
        <textarea [(ngModel)]="createLocation.description" name="description" class="k-textbox" rows="5"
          required></textarea>
        <div *ngIf="createLocation.description !== '' "
          [ngStyle]="{'color': (createLocation.description.length > 500) ? 'red' : inherit}">{{
          createLocation.description.length }}/500</div><br>
        <div *ngIf="userForm.form.controls['description'].invalid && userForm.form.controls['description'].touched"
          class="additionalExplanationErrors">
          <br>
          description is required
        </div>
        <div *ngIf="createLocation.description.length > 500" class="additionalExplanationErrors">
          description is too long (max 500 characters)
        </div><br>

        <!-- <label for="createLocation.locationTypeId">Location Type:</label><br>
        <input aria-label=""  [(ngModel)]="createLocation.locationTypeId" name="locationType" class="k-textbox" /><br><br> -->

        <label for="createLocation.locationType">location type:</label><br>
        <select [(ngModel)]="createLocation.locationTypeId" name="createLocation.locationTypeId"
          class="kendo-dropdownlist" (change)="updateLocationTypeAdd($event)">
          <option *ngFor="let locationType of createLocation.locationTypes" [value]="locationType.id">
            {{locationType.name }}
          </option>
        </select><br><br>
        <input aria-label="" type="hidden" [(ngModel)]="createLocation.locationTypeId"
          name="createLocation.locationTypeId" />

        <label for="createLocation.active" class="toggle-switch-label">active:</label>
        <label class="toggle-switch">
          <input aria-label="" type="checkbox" [(ngModel)]="createLocation.active" name="active"
            id="createLocation.active">
          <span class="slider"></span>
        </label><br><br>

        <div>
          <button kendoButton class="kendo-dialog-button" (click)="closeAddLocation()" role="button">cancel</button>
          <button kendoButton class="kendo-dialog-button" (click)="saveAddLocation(userForm)"
            [disabled]="createLocation.description.length > 500 || createLocation.name.length > 250">save</button>
        </div>
      </form>
    </kendo-dialog>
  </div>

  <!-- Edit Location Modal -->
  <div id="kendoEditLocation">
    <kendo-dialog *ngIf="openedEditLocation" (close)="closeEditLocation()">
      <kendo-dialog-titlebar id="editTitle">
        <div style="font-size: 18px; line-height: 1.3em;">
          edit location
        </div>
      </kendo-dialog-titlebar>

      <form id="LocationEdit" #userForm="ngForm" (ngSubmit)="saveEditLocation(userForm)">
        <label for="locationToEdit.name">name:</label><br>
        <input aria-label="" [(ngModel)]="locationToEdit.name" name="name" class="k-textbox" required />
        <div *ngIf="locationToEdit.name !== '' "
          [ngStyle]="{'color': (locationToEdit.name.length > 250) ? 'red' : inherit}">{{ locationToEdit.name.length
          }}/250</div><br>
        <div *ngIf="userForm.form.controls['name'].invalid && userForm.form.controls['name'].touched"
          class="additionalExplanationErrors">
          <br>
          name is required
        </div>
        <div *ngIf="locationToEdit.name.length > 250" class="additionalExplanationErrors">
          name is too long (max 250 characters)
        </div><br>

        <label for="locationToEdit.description">description:</label><br>
        <textarea [(ngModel)]="locationToEdit.description" name="description" class="k-textbox" rows="5"
          required></textarea>
        <div *ngIf="locationToEdit.description !== '' "
          [ngStyle]="{'color': (locationToEdit.description.length > 500) ? 'red' : inherit}">{{
          locationToEdit.description.length }}/500</div><br>
        <div *ngIf="userForm.form.controls['description'].invalid && userForm.form.controls['description'].touched"
          class="additionalExplanationErrors">
          <br>
          description is required
        </div>
        <div *ngIf="locationToEdit.description.length > 500" class="additionalExplanationErrors">
          description is too long (max 500 characters)
        </div><br>

        <label for="locationToEdit.locationTypeId">location type:</label><br>
        <select [(ngModel)]="locationToEdit.locationTypeId" name="locationToEdit.locationTypeId"
          class="kendo-dropdownlist" (change)="updateLocationTypeEdit($event)">
          <option *ngFor="let locationType of locationToEdit.locationTypes" [value]="locationType.id">
            {{locationType.name }}
          </option>
        </select><br><br>
        <input aria-label="" type="hidden" [(ngModel)]="locationToEdit.locationTypeId"
          name="locationToEdit.locationTypeId" />

        <label for="locationToEdit.active" class="toggle-switch-label">active:</label>
        <label class="toggle-switch">
          <input aria-label="" type="checkbox" [(ngModel)]="locationToEdit.active" name="active"
            id="locationToEdit.active">
          <span class="slider"></span>
        </label><br><br>

        <div>
          <button kendoButton class="kendo-dialog-button" (click)="closeEditLocation()" role="button">cancel</button>
          <button kendoButton class="kendo-dialog-button" (click)="saveEditLocation(userForm)"
            [disabled]="locationToEdit.description.length > 500 || locationToEdit.name.length > 250">save</button>
        </div>
      </form>
    </kendo-dialog>
  </div>

  <div id="kendoDeleteLocation">
    <kendo-dialog *ngIf="openedDeleteLocation" (close)="closeDeleteLocation()">
      <kendo-dialog-titlebar>
        <div style="font-size: 18px; line-height: 1.3em;">
          <span class="k-icon k-i-warning k-icon-md"></span> delete Location
        </div>
      </kendo-dialog-titlebar>
      <p style="margin: 30px; text-align: center;">
        are you sure you want to delete this location?
      </p>
      <kendo-dialog-actions>
        <button kendoButton class="kendo-dialog-button" (click)="closeDeleteLocation()" role="button">no</button>
        <button kendoButton class="kendo-dialog-button" (click)="confirmDeleteLocation()">yes</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  </div>

  <div id="kendoModal">
    <kendo-dialog *ngIf="openModal" (close)="onCloseModal()">
      <kendo-dialog-titlebar>
        <div style="font-size: 18px; line-height: 1.3em;">
          {{ modalTitle }}
        </div>
      </kendo-dialog-titlebar>
      <div>
        {{ modalMessage }}
      </div>
      <kendo-dialog-actions>
        <button kendoButton class="kendo-dialog-button" (click)="onCloseModal()">ok</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  </div>

</div>